<template>
  <div class="repeat-btn">
    <v-btn class="--notActive" icon @click="clickBtn('toAll')" v-if="$store.getters['musicPlayerModuleIsNotRepeat']"><v-icon color="grey">repeat</v-icon></v-btn>
    <v-btn class="--active" icon @click="clickBtn('toOne')" v-if="$store.getters.musicPlayerModuleIsRepeat">
      <v-icon>repeat</v-icon>
    </v-btn>
    <v-btn class="--active" icon @click="clickBtn('toNotRepeat')" v-if="$store.getters.musicPlayerModuleIsOneRepeat"><v-icon>repeat_one</v-icon></v-btn>
  </div>
</template>
<script>
export default {
  name: 'RepeatBtn',
  methods: {
    clickBtn (type) {
      switch (type) {
        case 'toAll':
          this.$store.dispatch('musicPlayerModuleSetRepeatFlag', 'all')
          break
        case 'toOne':
          this.$store.dispatch('musicPlayerModuleSetRepeatFlag', 'one')
          break
        default:
          this.$store.dispatch('musicPlayerModuleSetRepeatFlag', null)
          break
      }
    }
  }
}
</script>
<style scoped>
  .repeat-btn {
    color: #fff !important;
  }
  .--active /deep/ .icon{
    color: #15c06a!important;
  }
  .--notActive /deep/ .icon{
    color: #bdbdbd!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/RepeatBtn.vue